function normalizeKey(value) {
  if (value === null || value === undefined) return '';
  return String(value).trim().toLowerCase();
}

export function buildDomainIndex(domain) {
  const byKey = new Map();
  const byValue = new Map();
  for (const entry of domain || []) {
    if (entry.key != null) byKey.set(normalizeKey(entry.key), entry);
    if (entry.value != null) byValue.set(normalizeKey(entry.value), entry);
  }
  return { byKey, byValue };
}

function allowedValues(domain) {
  const seen = new Set();
  const out = [];
  for (const entry of domain) {
    const key = entry.key != null ? String(entry.key).trim() : '';
    const value = entry.value != null ? String(entry.value).trim() : '';
    let label;
    if (value && key && value !== key) {
      label = `${value} (${key})`;
    } else {
      label = value || key;
    }
    if (!label || seen.has(label)) continue;
    seen.add(label);
    out.push(label);
  }
  return out;
}

export function validateDomain(value, domain) {
  if (!Array.isArray(domain) || domain.length === 0) return { valid: true };
  if (value === null || value === undefined || value === '') return { valid: true };
  const { byKey, byValue } = buildDomainIndex(domain);
  const norm = normalizeKey(value);
  const hit = byKey.get(norm) || byValue.get(norm);
  if (!hit) {
    return { valid: false, code: 'DOMAIN', actual: value, expected: allowedValues(domain) };
  }
  return { valid: true, match: hit };
}
